import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Thumbs, Pagination } from "swiper/core";
import styled from "styled-components/macro";
import climaIMG from "assets/images/clima_img.png";

interface ProductImageProps {
  images: any[];
}

const ProductImage: React.FC<ProductImageProps> = ({ images }) => {
  const sortedImages = images.slice().sort((a, b) => a.is_main_image + b.is_main_image);

  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  const params = {
    spaceBetween: 12,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  const params2 = {
    slidesPerView: 4,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  };

  SwiperCore.use([Thumbs, Pagination]);

  return (
    <Container>
      {sortedImages.length === 0 ? (
        //TODO - add image with better quality
        <Image src={climaIMG} />
      ) : (
        <Swiper thumbs={{ swiper: thumbsSwiper }} {...params} pagination={{ clickable: true }} loop={true}>
          {sortedImages.map((item: any, idx: number) => {
            return (
              <SwiperSlide key={idx}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    aspectRatio: "4/3",
                  }}
                  key={idx}
                  src={`data:${item.contentType};base64,${item.image}`}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </Container>
  );
};

const Container = styled.div`
  height: 100%;

  .swiper-container,
  .swiper-slide {
    width: 100%;
    height: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export default ProductImage;
